import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs/internal/Observable';
import { merge } from 'rxjs';
import { mapTo, shareReplay } from 'rxjs/operators';

import { SgEntityBasedSession, UserSessionService, SgTopNavService } from '@sg/common/src';
import { CookiesSettingsDialogComponent } from '@sg/ui-kit/cookies-consent-dialog/src/lib/cookies-settings-dialog-wrapper/cookies-settings-dialog-wrapper.component';
import { UsersApi } from '@sg/api/users-api';

@Component({
  selector: 'sg-header-actions-menu',
  templateUrl: './header-actions-menu.component.html',
  styleUrls: ['./header-actions-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderActionsMenuComponent implements AfterViewInit {
  currentLegalEntity$ = this.session.currentEntity$;
  legalEntities$ = this.session.entities$;
  isOnColor$: Observable<boolean> = this.topNavService.isOnColor$;

  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;

  isMenuOpened$: Observable<boolean>;

  constructor(
    private session: SgEntityBasedSession,
    private userSession: UserSessionService,
    private dialog: MatDialog,
    private topNavService: SgTopNavService
  ) {}

  ngAfterViewInit(): void {
    this.isMenuOpened$ = this.initIsMenuOpened(this.menuTrigger);
  }

  selectLegalEntity(legalEntity: UsersApi.LegalEntityBaseDto) {
    this.session.changeEntity(legalEntity.id);
  }

  logout() {
    this.userSession.logout();
  }

  cookiesSettings() {
    this.dialog.open(CookiesSettingsDialogComponent, {
      maxWidth: '660px',
      backdropClass: 'sg-backdrop',
      panelClass: 'sg-cookies-settings-dialog',
      closeOnNavigation: true,
      autoFocus: false,
    });
  }

  private initIsMenuOpened(menuTrigger: MatMenuTrigger) {
    return merge(menuTrigger.menuClosed.pipe(mapTo(false)), menuTrigger.menuOpened.pipe(mapTo(true))).pipe(
      shareReplay(1)
    );
  }
}
